// extracted by mini-css-extract-plugin
module.exports = {"componentRoot":"ViewDesc_componentRoot__oxYgE"};